export const useScrollCarousel = (
    scrollBarRef: React.MutableRefObject<HTMLDivElement> | null,
) => ({
    scrollCarousel: (direction: number) => {
        if (!scrollBarRef?.current) return;
        const scrollbar = scrollBarRef.current;

        const chips = Array.from(scrollbar.children) as HTMLElement[];
        const navigationButtonWidth = 44;
        const flexboxGap = 8;
        const scrollbarEndPadding = 8;
        const extraSpace =
            flexboxGap + navigationButtonWidth - scrollbarEndPadding;

        // Calculate edges of the scrollbar taking into account the navigation button width
        const scrollbarRightEdge =
            scrollbar.scrollLeft + scrollbar.offsetWidth - extraSpace;
        const scrollbarLeftEdge = scrollbar.scrollLeft + extraSpace;

        // Find the target chip based on the scrolling direction
        const targetChip =
            direction > 0
                ? chips.find(
                      (chip) =>
                          chip.offsetLeft + chip.offsetWidth >
                          scrollbarRightEdge,
                  )
                : [...chips]
                      .reverse()
                      .find((chip) => chip.offsetLeft < scrollbarLeftEdge);

        // Scroll to the target chip if found
        if (targetChip) {
            // Calculate leftScroll as the distance to scroll such that the targetChip aligns to the left edge minus extraSpace
            const leftScroll = targetChip.offsetLeft - extraSpace;
            // Calculate rightScroll to align the targetChip's right edge with the scrollbar's right edge, adjusted by extraSpace
            const rightScroll =
                targetChip.offsetLeft +
                targetChip.offsetWidth -
                scrollbar.offsetWidth +
                extraSpace;

            scrollbar.scroll({
                left: direction > 0 ? leftScroll : rightScroll,
                behavior: 'smooth',
            });
        }
    },
});
